import * as AST from "./ast"

export default function() {
  return {
    fn: { AST }
  }
}



// WEBPACK FOOTER //
// ./src/plugins/ast/index.js